var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-container"},[_c('vue-slider',_vm._b({ref:"slider",staticClass:"slider",attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"change":_vm.valueChanged}},'vue-slider',_vm.options,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }